import formatTime from "../hooks/formatTime";
import "../../styles/CaesarСipherBoardLogo.css"
import { useTimerState } from "../../TimerContext";
type RenderBoardLogoProps = {
  isGameStarted: boolean;
  isGameFinished: boolean;
  onStart: () => void;
  onNext: () => void;
};
type BoardButtonProps = {
  isGameStarted: boolean;
  isGameFinished: boolean;
  onStart: () => void;
  onNext: () => void;
};
const BoardButton = ({
  isGameStarted,
  isGameFinished,
  onStart,
  onNext,
}: BoardButtonProps) => {
  if (!isGameStarted) {
    return (
      <button
        title="Начать игру"
        className="CaesarСipher-buttonCheck"
        onClick={() => {
          onStart();
        }}
      >
        Начать игру
        <img
          alt=""
          className="CaesarСipher-logoRun"
          src="/img/button/run-fix.svg"
        />
      </button>
    );
  }

  return (
    <button className="CaesarСipher-buttonCheck" onClick={onNext}>
      {isGameFinished ? "Играть ещё" : "Далее"}
      <img alt="" className="CaesarСipher-logoRun" src="/img/button/run-fix.svg" />
    </button>
  );
};
const RenderBoardLogo: React.FC<RenderBoardLogoProps> = ({
   isGameStarted,
  isGameFinished,
  onNext,
  onStart,
}) => {
   const { time, isTimerRunning } = useTimerState();
  return (
    <div className="CaesarСipher-board-logo">
      <img
        alt="logo"
        src="/img/transpos/person-transpos.svg"
        className="CaesarСipher-board-logo-image"
      ></img>

      <p className="CaesarСipher-subtitle" id="CaesarСipher-subtitle-board-logo">
        {isGameStarted && `Таймер: ${formatTime(time)}`}
      </p>
      <div id="CaesarСipher-board-logo-button">
        {!isTimerRunning && (
          <BoardButton
            isGameStarted={isGameStarted}
            isGameFinished={isGameFinished}
            onStart={onStart}
            onNext={onNext}
          />
        )}
      </div>
    </div>
  );
};
export default RenderBoardLogo;